export default {
  not_localised: "Ce document n'est pas encore disponible dans votre région. Affichage de la version anglaise.",
};
